import { QueryClient } from '@tanstack/react-query';

/**
 * O cliente do React Query do app. Mora fora do `main.tsx` para que o teste que depende da
 * repetição das consultas use estas mesmas opções, e não uma cópia que diverge do app (LC-11).
 */
export function criarQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false, // Desabilita refetch ao focar na janela
        retry: 1, // Tenta novamente 1 vez em caso de erro
        staleTime: 5 * 60 * 1000, // Considera dados "frescos" por 5 minutos
      },
    },
  });
}
